module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_8004.c52e61a2.png";